export default __webpack_public_path__ + "static/summerweek1-1b268283a9ffc0213e0fc499ae1f9536.png";